import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useState, createContext, useContext } from 'react';
export var ReviewContext = /*#__PURE__*/ createContext({
    reviewList: [],
    expandedReviewList: [],
    expandedReviewId: '',
    mode: '',
    setReviewList: function setReviewList() {},
    setExpandedReviewList: function setExpandedReviewList() {},
    setExpandedReviewId: function setExpandedReviewId() {},
    setMode: function setMode() {},
    clearState: function clearState() {}
});
var ReviewContextProvider = function ReviewContextProvider(props) {
    var _useState = _sliced_to_array(useState([]), 2), reviewList = _useState[0], setReviewList = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), expandedReviewList = _useState1[0], setExpandedReviewList = _useState1[1];
    var _useState2 = _sliced_to_array(useState(''), 2), expandedReviewId = _useState2[0], setExpandedReviewId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(''), 2), mode = _useState3[0], setMode = _useState3[1];
    var clearState = function clearState() {
        setMode('');
        setExpandedReviewId('');
        setReviewList([]);
        setExpandedReviewList([]);
    };
    return /*#__PURE__*/ _jsx(ReviewContext.Provider, {
        value: {
            reviewList: reviewList,
            expandedReviewList: expandedReviewList,
            expandedReviewId: expandedReviewId,
            mode: mode,
            setReviewList: setReviewList,
            setExpandedReviewList: setExpandedReviewList,
            setExpandedReviewId: setExpandedReviewId,
            setMode: setMode,
            clearState: clearState
        },
        children: props.children
    });
};
var useReview = function useReview() {
    return useContext(ReviewContext);
};
export { ReviewContextProvider, useReview };
